import _ from 'underscore';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getEntityUrl } from '@culture/utils/helpers/entities';

import Tag from 'components/Tag';

import { useTabNavigation } from 'hooks/useTabNavigation';
import styles from './styles.module.scss';

const TagList = ({ tags, title, align, allTagsOnMobile, tagCountOnMobile }) => {
	const [showMobileTags, setShowMobileTags] = useState(allTagsOnMobile);

	useEffect(() => {
		setShowMobileTags(allTagsOnMobile);
	}, [tags, allTagsOnMobile]);

	const onClick = useCallback(() => {
		setShowMobileTags(true);
	}, []);

	const itemButtonCx = cx(styles.item, {
		[styles.hide_tabletLarge]: !showMobileTags
	});

	const {
		firstListItemRef,
		handleBlur,
		handleFocus,
		handleKeyDown,
		listItemTabIndex
	} = useTabNavigation();

	return (
		<div
			className={styles.list}
			aria-label="Тэги"
			role="toolbar"
			aria-orientation="horizontal"
			tabIndex={0}
			onBlur={handleBlur}
			onFocus={handleFocus}
			onKeyDown={handleKeyDown}
		>
			{!!title && <div className={styles.title}>{title}</div>}
			<div className={cx(styles.container, styles[align])}>
				{_(tags).map((tag, index) => {
					const url = tag.url || getEntityUrl('tags', tag);
					const itemLinkCx = cx(styles.item, {
						[styles.show_tabletLarge]:
							index > tagCountOnMobile - 1 && !showMobileTags
					});

					return (
						<div className={itemLinkCx} key={url}>
							<Tag
								title={tag.title}
								url={url}
								tabIndex={listItemTabIndex}
								ref={index === 0 ? firstListItemRef : null}
							/>
						</div>
					);
				})}
				{tags.length > tagCountOnMobile && !showMobileTags && (
					<div className={itemButtonCx}>
						<Tag title="Ещё..." onClick={onClick} tabIndex={listItemTabIndex} />
					</div>
				)}
			</div>
		</div>
	);
};

TagList.propTypes = {
	tags: PropTypes.array.isRequired,
	title: PropTypes.string,
	align: PropTypes.oneOf(['center']),
	allTagsOnMobile: PropTypes.bool,
	tagCountOnMobile: PropTypes.number
};

TagList.defaultProps = {
	allTagsOnMobile: false,
	tagCountOnMobile: 2
};

export default TagList;
